import { useFormContext } from 'react-hook-form';

import type { FormCheckboxProps } from '../types';
import type { FieldValues } from 'react-hook-form';

import { Checkbox } from '@/components/ui/checkbox';
import {
  Field,
  FieldContent,
  FieldDescription,
  FieldError,
  FieldLabel,
} from '@/components/ui/field';
import { FormField } from '@/components/ui/form';

import { cn } from '@/lib/utils';

export const FormCheckbox = <TFieldValues extends FieldValues = FieldValues>(
  props: FormCheckboxProps<TFieldValues>,
) => {
  const {
    name,
    label,
    description,
    isRequired,
    disabled,
    checkboxProps,
    control,
  } = props;
  const formContext = useFormContext<TFieldValues>();
  const formControl = control || formContext.control;

  const fieldId = `form-field-${String(name)}`;

  return (
    <FormField
      control={formControl}
      name={name}
      render={({ field, fieldState }) => (
        <Field
          data-invalid={fieldState.invalid}
          orientation="horizontal"
        >
          <Checkbox
            id={fieldId}
            checked={field.value || false}
            onCheckedChange={(checked) => {
              field.onChange(checked);
            }}
            disabled={disabled}
            aria-invalid={fieldState.invalid}
            {...checkboxProps}
          />
          <FieldContent>
            {label && (
              <FieldLabel
                htmlFor={fieldId}
                className="cursor-pointer"
              >
                {label}
                {isRequired && (
                  <span
                    className={cn(
                      'ml-1',
                      fieldState.invalid
                        ? 'text-destructive'
                        : 'text-muted-foreground',
                    )}
                  >
                    *
                  </span>
                )}
              </FieldLabel>
            )}
            {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
            {description && <FieldDescription>{description}</FieldDescription>}
          </FieldContent>
        </Field>
      )}
    />
  );
};
